import { useEffect, useState } from 'react'
import { commandPayload, commands, isLiveRuntime } from '../../lib/runtime'
import { useAuth } from './auth/AuthContext'

/**
 * Whether the signed-in person has a phone number on file.
 *
 * The shared profile projection never carries phone numbers, so this asks the
 * server for the caller's own profile. Undefined until known, so a checklist
 * can leave the step out instead of nagging someone who already added one.
 */
export const useHasPhone = (profileId: string): boolean | undefined => {
  const { user } = useAuth()
  const [known, setKnown] = useState<boolean | undefined>(user?.phone ? true : undefined)
  useEffect(() => {
    if (user?.phone) {
      setKnown(true)
      return
    }
    if (!profileId || !isLiveRuntime()) return
    let active = true
    void commands.profile
      .getProfile(profileId)
      .then((response) => {
        if (active) setKnown(Boolean(String(commandPayload(response).phone ?? '').trim()))
      })
      .catch(() => undefined)
    return () => {
      active = false
    }
  }, [profileId, user?.phone])
  return known
}
